import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartShopping, faHeart, faHome, faUser, faSearch } from "@fortawesome/free-solid-svg-icons";
import { faHeart as faHeartO, faHome as faHomeO, faUser as faUserO } from "@fortawesome/free-regular-svg-icons";

import classNames from "classnames";
import { faCartFlatbed, faLayerGroup } from "@fortawesome/free-solid-svg-icons";

import "../../styles/header.css";
import { getWishListItems, loadCartItems } from "../../_helpers/cart.methods";
import { useAuthentication } from "../../services/authentication/authentication.context";
import { useProduct } from "../../services/products/product.context";
import { SearchForm } from "../forms/search-form";


export const SiteHeader = ({ pageTitle }) => {

    const { isAuthenticated } = useAuthentication();
    const { cart, wishList } = useProduct();

    const [language, setLanguage] = useState('en')

    const isActive = (url) => {
        return window.location.pathname === url
    }

    const [cartquantity, setCartquantity] = useState(0);
    const [liked, setLiked] = useState(0);
    const [showSearchBar, setShowSearchBar] = useState(false);

    const handleSetLanguage = () => {
        if (language === 'en') {
            window.location.href = "/fr";
            localStorage.setItem('language','fr');
        }else {
            window.location.href = "/";
            localStorage.setItem('language','en');
        }
    }

    useEffect(() => {
        document.title = pageTitle;
        setCartquantity(cart?.length);
        setLiked(wishList?.length);

        //auto scroll upon page change
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        const lang = localStorage.getItem('language');
        if (lang === 'fr') {
            window.location.href = "/fr";
        }else {
            return;
        }
    }, [pageTitle, cart, wishList, language])


    return (
        <header>
            {showSearchBar &&
                <SearchForm onClose={() => setShowSearchBar(false)} />
            }
            <div className="header-bar">
                <img src="/logos/logo.png" alt="" className="app-logo" />
                <div className="site-names">
                    <div className="site-name prim">KEVO</div>
                    <div className="site-name sec">TELECOM</div>
                </div>
                <button
                    className="tr-btn"
                    onClick={() => setShowSearchBar(true)}
                >
                    <FontAwesomeIcon className="s-icon" icon={faSearch} />
                </button>
                <button className="lang-button" onClick={handleSetLanguage}>
                    <span className="lang-label">
                        {language === 'en' ? 'Fr': 'En'}
                    </span>
                    <img
                        src={language === 'en' ? "/logos/fr.png" : "/logos/en.png"}
                        alt=""
                        className="lang-img"
                    />
                </button>
            </div>
            <div className="nav-bar">
                <button
                    className={classNames('nav-button', { 'active': isActive('/') })}
                    onClick={() => window.location.href = "/"}
                >
                    <FontAwesomeIcon icon={isActive("/") ? faHome : faHomeO} />
                    <span className="button-label">Home</span>
                </button>
                <button
                    className={classNames('nav-button', { 'active': isActive('/categories') })}
                    onClick={() => window.location.href = "/categories"}
                >
                    <FontAwesomeIcon icon={faLayerGroup} />
                    <span className="button-label">Categories</span>
                </button>
                <button
                    className={classNames('nav-button', { 'active': isActive('/wishlist') })}
                    onClick={() => window.location.href = "/wishlist"}
                >
                    {liked > 0 &&
                        <div className="cart-quantity">
                            {liked}
                        </div>
                    }
                    <FontAwesomeIcon icon={isActive("/wishlist") ? faHeart : faHeartO} />
                    <span className="button-label">Wish list</span>
                </button>
                <button
                    className={classNames('nav-button', { 'active': isActive('/cart') })}
                    onClick={() => window.location.href = "/cart"}
                >
                    {cartquantity > 0 &&
                        <div className="cart-quantity">
                            {cartquantity}
                        </div>
                    }
                    <FontAwesomeIcon icon={faCartShopping} />
                    <span className="button-label">Cart</span>
                </button>
                <button
                    className={classNames('nav-button', { 'active': isActive('/login') })}
                    onClick={() => {
                        isAuthenticated ? window.location.href = '/admin' : window.location.href = "/login"
                    }}
                >
                    <FontAwesomeIcon icon={isActive("/login") ? faUser : faUserO} />
                    <span className="button-label">Account</span>
                </button>

            </div>
        </header>
    )
}